<div class="container px-4 mx-auto">
  <div class="max-w-lg mx-auto">
    <div class="text-center mb-6">
      <h2 class="text-3xl md:text-4xl font-extrabold text-purple-700 m-3">
        Review And Rating
      </h2>
      <div class="flex justify-center">
        <img
          [src]="ratingImageUrl + productDetails?.images[0]"
          class="m-5 object-contain w-32 h-32"
        />
      </div>
      <p class="text-sm font-bold">
        {{ productDetails?.productDetails?.productName }}
      </p>
    </div>
    <form>
      <p class="text-xl font-semibold mt-3">Rating</p>
      <p></p>
      <div class="flex gap-0.5">
        <ng-container>
          <!-- [name]="star.color =='warning' ? 'star' :'star-outline'"
                  [color]="star.color"> -->
          <div *ngFor="let star of stars; let i = index" (click)="rate(i)">
            <svg
              [ngClass]="
                star.color == 'warning'
                  ? 'fill-yellow-400 h-12 w-12 shrink-0 stroke-none'
                  : 'fill-none stroke-2 h-12 w-12 shrink-0'
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                stroke="currentColor"
                stroke-linejoin="round"
                d="M480 208H308L256 48l-52 160H32l140 96l-54 160l138-100l138 100l-54-160Z"
              />
            </svg>
          </div>
        </ng-container>
      </div>

      <p class="text-xl font-semibold mt-3">Attach Photos and Videos</p>
      <div class="flex lg:h-20 mb-11 w-full object-contain">
        <div
          class="inline-block max-w-max"
          *ngFor="let item of img1; let i = index"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            (click)="deleteItem(item, i)"
            class="flex absolute w-8 h-8 ml-16 p-1 mx-2 text-red-400 object-right cursor-pointer"
            viewBox="0 0 24 24"
          >
            <path
              fill="red"
              d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
            />
          </svg>
          <img
            [src]="item.image"
            class="w-24 h-24 mr-2 rounded ml-2 card shadow-md shadow-black"
            (click)="selectImage(item, i)"
          />
        </div>
        <!-- *ngIf="img1.length!= 5" -->
        <div
          class="addbtn h-24 w-24 rounded-lg flex flex-shrink-0 justify-center items-center text-white text-3xl font-mono"
          *ngIf="img1.length != 5"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            (click)="fileInput.click()"
            class="w-9 h-9"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M3 21q-.825 0-1.412-.587T1 19V7q0-.825.588-1.412T3 5h3.15L7.4 3.65q.275-.3.663-.475T8.875 3H13q.425 0 .713.288T14 4t-.288.713T13 5H8.875L7.05 7H3v12h16v-8q0-.425.288-.712T20 10t.713.288T21 11v8q0 .825-.587 1.413T19 21zM19 5h-1q-.425 0-.712-.288T17 4t.288-.712T18 3h1V2q0-.425.288-.712T20 1t.713.288T21 2v1h1q.425 0 .713.288T23 4t-.288.713T22 5h-1v1q0 .425-.288.713T20 7t-.712-.288T19 6zm-8 12.5q1.875 0 3.188-1.312T15.5 13t-1.312-3.187T11 8.5T7.813 9.813T6.5 13t1.313 3.188T11 17.5m0-2q-1.05 0-1.775-.725T8.5 13t.725-1.775T11 10.5t1.775.725T13.5 13t-.725 1.775T11 15.5"
            />
          </svg>
          <input
            type="file"
            (change)="fileChoose($event)"
            style="display: none"
            accept="*"
            id="file-input"
            multiple
            #fileInput
          />
        </div>
      </div>

      <div class="mb-2">
        <label
          for="message"
          class="block mb-2 text-xl font-semibold text-gray-900 dark:text-gray-700"
          >Your message</label
        >
        <textarea
          id="message"
          rows="4"
          class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-purple-700 focus:ring-blue-500 focus:border-blue-500 dark:bg-white border-2 dark:placeholder-gray-500 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
          [(ngModel)]="userReview"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Write your thoughts here..."
        ></textarea>
      </div>
      <button
        (click)="cancel()"
        class="inline-block w-1/4 py-4 mb-6 text-center text-lg leading-6 text-purple-700 font-bold border-2 border-purple-700 shadow rounded transition duration-200"
      >
        Cancel
      </button>

      <button
        class="addbtn inline-block w-1/4 py-4 float-end mb-6 text-center text-lg leading-6 text-white font-bold shadow rounded transition duration-200"
        (click)="submitReview()"
      >
        Submit
      </button>
    </form>
  </div>
</div>
